import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  //获取年份
  getYears({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/selectYearList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 拉取数据
  pullData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/pullData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 风险提示
  riskTips({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/riskTips`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // AI分数同步
  updateAiScore({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/updateAiScore`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 专业优化分同步
  updateProfessionalScore({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/updateProfessionalScore`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //获取批次/科类
  getBatchNumAndSubject({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/selectBatchAndSubjectOpt`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 列表查询
  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/selectMainListData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导出
  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  checkImportExcelNum({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/checkImportExcelNum`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导入
  importExcel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/importExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取版本
  selectVersion({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/selectVersionList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 人工动分
  editData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/editData`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 自动修改
  autoEdit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/autoEditData`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 保存
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/saveData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 另存
  saveAs({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/saveAsData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
